<template>
  <div class="spinner-action" :class="{ 'spinner-active': isSpinner }">
    <div class="spinner-border text-dark icon-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  data: () => ({
    isSpinner: false
  }),
  mounted() {
    var that = this
    this.$bus.$on('spinner', function (e) {
      that.isSpinner = e
      if (e == true) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    })
  }
}
</script>

<style lang="scss" scope>
.spinner-action {
  display: none;
  position: fixed;
  background: #000;
  opacity: 0.4;
  z-index: 1501;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  .icon-spinner {
    position: absolute;
    top: calc(50% - 1rem);
    left: calc(50% - 1rem);
  }
  &.spinner-active {
    display: block;
    overflow: hidden;
  }
}
</style>
